module.exports = __webpack_public_path__ + "img/brand_mark.52a82d15.png";